import React from "react";
import { BlockContent } from "../BlockContent/BlockContent";

export type TableData = {
  tableRows: TableRowData[];
  caption: string;
};

export type TableRowData = {
  tableCells: TableCellData[];
  _key: string;
};

export type TableCellData = {
  content: any;
  _key: string;
};

export interface TableProps {
  data: TableData;
  className?: string;
  language: string;
}

export const Table: React.FC<TableProps> = ({
  className,
  language,
  data: { tableRows, caption },
}) => {
  return (
    <table tabIndex={0}>
      <caption>{caption}</caption>
      <tbody>
        {tableRows.map((row) => {
          return (
            <TableRow
              tableCells={row.tableCells}
              language={language}
              key={row._key}
            />
          );
        })}
      </tbody>
    </table>
  );
};

interface TableRowProps extends TableRowData {
  language: string;
}

const TableRow: React.FC<TableRowProps> = ({ tableCells, language }) => {
  return (
    <tr>
      {tableCells.map((cell, index) => {
        if (index === 0) {
          return (
            <th scope="col" key={cell._key}>
              <BlockContent nested blocks={cell.content} language={language} />
            </th>
          );
        }
        return (
          <td key={cell._key}>
            <BlockContent nested blocks={cell.content} language={language} />
          </td>
        );
      })}
    </tr>
  );
};
